<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Branch Name</label>
                  <input type="text"  v-model="form.branchname"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Branch Head</label>
                  <input type="text"  v-model="form.branchhead"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text"  v-model="form.email"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>State</label>
                  <select class="form-control" v-model="form.statecode">
                    <option value="">Select state</option>
                    <option v-for="state in states" :key="state.statecode" :value="state.statecode">
                      {{ state.statename }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-sm-6 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <input type="text"  v-model.number="form.phone"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Update</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        branchname: '',
        branchhead: '',
        phone: '',
        email: '',
        statecode: '',
      },
      states: [],
      filter: true,
      id: this.$route.query.id,
      title: "Edit Branch",
      title1: "Edit",
    };
  },
  methods: {
    async getStates() {
      const response = await axios.get('/v1/states');
      this.states = response.data;
    },
    postData() {
      if (!this.form.branchname) {
        Swal.fire("Please enter the branch name");
        return;
      }
      if (!this.form.statecode) {
        Swal.fire("Please select a state");
        return;
      }
      axios
      .put('/v1/branches/' + this.id, this.form)
      .then(response => {
        Swal.fire("Branch updated successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getBranchById(id) {
      axios
      .get('/v1/branches/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getStates();
    this.getBranchById(this.id);
  },
  name: "editcustomer",
};
</script>

